import { Link } from 'react-router-dom'
import React from 'react'
import Swal from 'sweetalert2'
// import changeEstatusPermisionarioService from './../../services/changeEstatusPermisionarioService';

export default function TableElementProceso({ element, permisosUsuario }) {
    let { id_proceso, nombre, nombre_unidad, costo, activo } = element

    const [estadoEstatus, setEstadoEstatus] = React.useState(activo)

    const onClickEstatus = activo => {
        let msg = activo ? 'Quieres habilitar el proceso?' : 'Quieres deshabilitar el proceso?'
        let txt = activo ? 'Habilitar' : 'Deshabilitar'
        Swal.fire({
            title: msg,
            showCancelButton: true,
            confirmButtonText: txt,
            showLoaderOnConfirm: true,
            allowOutsideClick: () => !Swal.isLoading(),
        }).then(result => {
            if (result.isConfirmed) {
                // let values = new FormData()
                // values.append('folio', folio)
                // values.append('activo', activo)
                // let objectValues = Object.fromEntries(values);
                // // console.log({objectValues})
                // changeEstatusPermisionarioService({values:objectValues}).then(response => {
                //     // console.log(response)
                //     let _respuesta = JSON.parse(response);
                //     if (_respuesta.response === "success") {
                //         setEstadoEstatus(activo)
                //         Swal.fire(
                //             'Estatus actualizado',
                //             '',
                //             'success'
                //         )
                //     }
                // })
            }
        })
    }

    return (
        <tr key={id_proceso}>
            <th>
                <div className="table__name">
                    <div className="dropdown">
                        <button
                            type="button"
                            className="btn dropdown-toggle"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        />
                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <Link to={`/procesos/${id_proceso}`} className="dropdown-item">
                                Ver
                            </Link>
                            {/* {
                                (permisosUsuario.procesos.editar === '1') &&
                                    (estadoEstatus == '1' ?
                                    <a className="dropdown-item bg-danger text-white" onClick={() => onClickEstatus(false)}>Deshabilitar</a>
                                    :
                                    <a className="dropdown-item bg-success text-white" onClick={() => onClickEstatus(true)}>Habilitar</a>)
                            } */}
                        </div>
                    </div>

                    <div className="table__nameDescription">
                        <p>{nombre}</p>
                        <small>id proceso: {id_proceso}</small>
                    </div>
                </div>
            </th>

            <td>
                <p>{nombre_unidad}</p>
            </td>

            <td>{costo > 0 ? `$ ${costo}` : '-'}</td>

            <td>
                <div className="table__estatus">
                    <span className={estadoEstatus == '1' ? '' : 'table__estatus-inactive'}>
                        {estadoEstatus == '1' ? 'Activo' : 'Inactivo'}
                    </span>
                </div>
            </td>
        </tr>
    )
}
